export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/decc719ac0c1523cc2040d71b927dcbc.svg";